import Button from '@/components/base/button/button';
import PhosphorIcon from '@/components/base/icon/phosphor-icon';
import {
  type FlyBasketStore,
  useFlyBasketStore,
} from '@/store/fly-basket-store';
import { CheckCircle, XCircle } from '@phosphor-icons/react';
import { useTranslations } from 'next-intl';

const selector = (state: FlyBasketStore) => ({
  handleClose: state.close,
});

export const Header = () => {
  const { handleClose } = useFlyBasketStore(selector);
  const t = useTranslations('navigation.fly_basket');

  return (
    <div className="flex gap-xxs py-xxs s:pr-xs xs:pr-xxs pl-xs s:pl-inner xs:pl-s">
      <h2 className="flex w-full items-center gap-xxs">
        <PhosphorIcon
          Icon={CheckCircle}
          className="icon-m text-success"
          variant="fill"
        />
        <span className="text-heading-m text-strong">
          {t('added_to_basket')}
        </span>
      </h2>
      <div>
        <Button
          variant="tertiary-no-frame"
          className="h-clickable w-clickable"
          onClick={handleClose}
        >
          <PhosphorIcon Icon={XCircle} className="icon-m" />
          <span className="sr-only">{t('close')}</span>
        </Button>
      </div>
    </div>
  );
};
